import React from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import { getCryptoPaymentAll } from '../../api/getCryptoPaymentAll';
import { getFormattedDateAndTimeWithoutConverting } from '../../helpers/getFormattedDate';
import { routes } from '../../routes';
import { getCryptoInvoce } from '../../api/getCryptoInvoce';
import { getErrorMessage } from '../../helpers/getErrorMessage';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import CardActions from '@mui/material/CardActions';

const useStyles = makeStyles(() => ({
  block: {
    padding: '20px',
  },
  error: {
    color: 'red',
  },
}));

export default function Index() {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [expandedId, setExpandedId] = React.useState(-1);

  const { isLoading, data } = useQuery('usersData', getCryptoPaymentAll, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const handleExpandClick = (i) => {
    setExpandedId(expandedId === i ? -1 : i);
  };

  if (data instanceof Error) {
    if (data.response?.status === 401) {
      history.push(routes.login);
      return null;
    }
    return (
      <>
        <div className={classes.block}>
          <h3 className={classes.error}>
            {data.response ? data.response.data.message : data.message}
          </h3>
        </div>
      </>
    );
  }

  const handleClickOpen = () => {
    //нужно сделать нормальную можалку на перепрос пользователя для оплаты
    async function fetchData() {
      const res = await getCryptoInvoce();
      if (!(res instanceof Error)) {
        alert(
          'Счеёт успешно сформирован: ' +
            res.invoiceid +
            '\nCейчас вас переведут на страницу оплаты CryptoCloud'
        );
        window.location.href = res.payurl;
      } else {
        alert('При выставлении счёта произошла ошибка: ' + getErrorMessage(res));
      }
    }
    fetchData();
  };

  return (
    <>
      <div className={classes.block}>
        <h4>Принимаем платежи в криптовалюте онлайн через партнера CryptoCloud</h4>
        <h4>Подписка на одного пользователя 5 USD в месяц</h4>
        <Button variant="contained" color="primary" onClick={handleClickOpen}>
          {t('pay_with_cryptoCloud')}
        </Button>
        <h4>История выставление счетов</h4>
        {data &&
          data.map((row, index) => (
            <Card key={index} sx={{ mt: 2 }}>
              <CardContent>
                <div>{`${getFormattedDateAndTimeWithoutConverting(row.dt)}`}</div>
                <div>{`Статус: ${row.Statusinvoice}`}</div>
                <div>
                  Сcылка для оптаны: <a href={row.payurl}>{row.payurl}</a>
                </div>
              </CardContent>
              <Collapse in={expandedId === index} timeout="auto" unmountOnExit>
                <CardContent>
                  <div>{`Идентификатор платежа: ${row.invoiceid}`}</div>
                  <div>{`Сумма платежа: ${row.amount} ${row.currency}`}</div>
                  <div>{`Дата обновления статуса: ${getFormattedDateAndTimeWithoutConverting(
                    row.dtpaym
                  )}`}</div>
                </CardContent>
              </Collapse>
              <CardActions>
                <Button
                  size="small"
                  onClick={() => handleExpandClick(index)}
                  aria-expanded={expandedId === index}
                >
                  {t('more')}
                </Button>
              </CardActions>
            </Card>
          ))}
        {isLoading && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </div>
    </>
  );
}
